import { z } from "zod";
import { Fetcher } from "../../../../fetcher";
import { CognitoIdToken } from "../../../users/authTypes";
import { HistoricalPrice, historicalPriceSchema } from "../../../bonds/historicalPrices/historicalPrices";
import { CorporateBondId } from "@goodfill/domain-properties";

const schema = z.object({
  previousState: z.array(historicalPriceSchema),
  newState: z.array(historicalPriceSchema),
  report: z.object({
    additions: z.array(historicalPriceSchema),
    omissions: z.array(historicalPriceSchema),
    changes: z.array(
      z.object({
        original: historicalPriceSchema,
        new: historicalPriceSchema,
      }),
    ),
  }),
});

export type ApiBulkUpsertHistoricalPricesOkResponse = z.infer<typeof schema>;

export interface UpsertBondHistoricalDataRequest {
  corporateBondCusipId: CorporateBondId;
  dailyHistoricalPrices: HistoricalPrice[];
  // all DailyHistoricalPrices.bondCusipId must equal to corporateBondCusipId above
  // each date must be only present at most once. It is fine for the date range to contain holes.
}

export const bulkUpsertHistoricalPrices = (
  fetcher: Fetcher,
  cognitoIdToken: CognitoIdToken,
  data: UpsertBondHistoricalDataRequest,
) => {
  return fetcher({
    endpoint: "/traderUi/bonds/historicalPrices/bulkUpsert",
    data,
    method: "POST",
    schema,
    cognitoIdToken,
  });
};
